import {createColorScheme} from "frontend/theme/utils";

export default {
    primary: createColorScheme("#007d7e"),
    background: createColorScheme("#ffffff"),
    negative: createColorScheme("#b4191f"),
    cardBackground: createColorScheme("#e6e6e6"),
}
